import React from 'react';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSelectedDashboardDatabaseRevisionId = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const param = searchParams.get('dashboardDatabaseRevisionId');
    return param ?? '';
  }, [searchParams]);
};
